module.exports = __webpack_public_path__ + "static/media/bitcoin.6f74e3f9.svg";